// 钱包模块状态管理
import { Indicator } from 'mint-ui'
import { fetchWalletFlow, fetchWalletInfo } from '../common/api/wallet.js'

// const testList = [
//   { flowType: 1, title: '用户提现1', dateTime: '2019/9.19 09:39:23', amount: 90999, orderID: '123r423534' },
//   { flowType: 2, title: '用户提现2', dateTime: '2019/9.19 09:39:23', amount: 90999, orderID: '123r423534' },
//   { flowType: 1, title: '用户提现', dateTime: '2019/9.19 09:39:23', amount: 909990, orderID: '123r423534' },
//   { flowType: 2, title: '用户提现', dateTime: '2019/9.19 09:39:23', amount: 90900, orderID: '123r423534' },
//   { flowType: 1, title: '用户提现', dateTime: '2019/9.19 09:39:23', amount: 90999, orderID: '123r423534' },
//   { flowType: 2, title: '用户提现3', dateTime: '2019/9.19 09:39:23', amount: 90999, orderID: '123r423534' },
//   { flowType: 1, title: '用户提现', dateTime: '2019/9.19 09:39:23', amount: 90999, orderID: '123r423534' },
//   { flowType: 1, title: '用户提现', dateTime: '2019/9.19 09:39:23', amount: 90999, orderID: '123r423534' },
//   { flowType: 2, title: '用户提现4', dateTime: '2019/9.19 09:39:23', amount: 90999, orderID: '123r423534' },
//   { flowType: 1, title: '用户提现', dateTime: '2019/9.19 09:39:23', amount: 90999, orderID: '123r423534' },
//   { flowType: 1, title: '用户提现', dateTime: '2019/9.19 09:39:23', amount: 90999, orderID: '123r423534' },
//   { flowType: 2, title: '用户提现5', dateTime: '2019/9.19 09:39:23', amount: 90999, orderID: '123r423534' },
//   { flowType: 1, title: '用户提现', dateTime: '2019/9.19 09:39:23', amount: 90999, orderID: '123r423534' },
//   { flowType: 1, title: '用户提现6', dateTime: '2019/9.19 09:39:23', amount: 90999, orderID: '123r423534' },
//   { flowType: 2, title: '用户提现', dateTime: '2019/9.19 09:39:23', amount: 90999, orderID: '123r423534' },
//   { flowType: 1, title: '用户提现', dateTime: '2019/9.19 09:39:23', amount: 90999, orderID: '123r423534' },
//   { flowType: 1, title: '用户提现77', dateTime: '2019/9.19 09:39:23', amount: 90999, orderID: '123r423534' },
// ]

const state = {
  // 流水页日期选择
  // runningCountDate: new Date(Date.now()),
  runningCountDate: '',
  // 流水页删选勾选项
  runningCountFilterType: 0,
  // 流水页数据列表
  runningCountDataList: [],
  runningCountDataEnd: false,
  runningCountDataLoading: false,
  runningCountDataError: false,
  // 个人钱包基本信息：余额，单日提现上限，支付宝账户信息
  mainInfo: null,
}

const actions = {
  // 请求列表数据
  async GET_RC_LIST ({ commit }, { pageSize, pageNum, flowType, dateMonth }) {
    commit('SET_RC_LOADING_STATUS', true)
    // const res = await testFetch({ pageSize, pageNum, type, dateTime })
    // console.log('{ pageSize, pageNum, type, dateTime }', { pageSize, pageNum, flowType, dateMonth })
    try {
      const res = await fetchWalletFlow({ pageSize, pageNum, flowType, dateMonth })
      const { errorCode, flowList, isEnd } = res // errorMsg
      // debugger
      Indicator.close()
      if (errorCode === 0) {
        commit('SET_RC_LOADING_STATUS', false)
        commit('SET_RC_END_STATUS', isEnd)
        commit('SET_RC_DATA_LIST', { data: flowList, isAdd: pageNum > 1 })
      } else {
        commit('SET_RC_END_STATUS', true)
      }
    } catch (e) {
      Indicator.close()
      commit('SET_RC_LOADING_STATUS', false)
      commit('SET_RC_END_STATUS', true)
      commit('SET_RC_ERROR_STATUS', true)
    }
  },
  // 请求用户钱包基本信息
  async GET_WALLET_MAIN_INFO ({ commit }, data = {}) {
    try {
      const res = await fetchWalletInfo().catch(() => { Indicator.close() }) // 异常兜底去除 loading
      const { errorCode } = res
      Indicator.close()
      if (errorCode === 0) {
        commit('SET_WALLET_BASE_INFO', { data: res })
      }
    } catch (e) {}
  }
}

const mutations = {
  SET_RC_DATA_LIST (state, { data, isAdd }) {
    state.runningCountDataList = (isAdd ? [ ...state.runningCountDataList, ...data ] : data)
  },
  SET_RC_END_STATUS (state, payload) {
    state.runningCountDataEnd = payload
  },
  SET_RC_LOADING_STATUS (state, payload) {
    state.runningCountDataLoading = payload
  },
  SET_RC_ERROR_STATUS (state, payload) {
    state.runningCountDataError = payload
  },
  SET_RC_DATE (state, payload) {
    state.runningCountDate = payload
  },
  SET_RC_TYPE (state, payload) {
    state.runningCountFilterType = payload
  },
  SET_WALLET_BASE_INFO (state, payload) {
    state.mainInfo = payload
  },
}

export default {
  state, actions, mutations
}
